import client from './client'
import type { User } from '../types/auth'

export async function login(username: string, password: string): Promise<User> {
  return await client.post<User>('/auth/login', { username, password })
}

export async function fetchCurrentUser(): Promise<User> {
  return await client.get<User>('/auth/me')
}

export async function logout(): Promise<void> {
  try {
    await client.post('/auth/logout')
  } finally {
    const { logoutFromEntra } = await import('./entra')
    await logoutFromEntra()
  }
}

export async function getSessionId(): Promise<string> {
  const res = await client.get<{ session_id: string }>('/auth/session-id')
  return res.session_id
}

export async function updateMe(data: {
  current_password: string
  new_username?: string
  new_password?: string
}): Promise<User> {
  return await client.put<User>('/auth/me', data)
}

export async function fetchUsers(): Promise<User[]> {
  return await client.get<User[]>('/users/')
}

export async function createUser(data: {
  username: string
  password: string
  display_name: string
  role: string
}): Promise<User> {
  return await client.post<User>('/users/', data)
}

export async function updateUser(userId: number, data: Partial<{ username: string; display_name: string; role: string; password: string; is_active: boolean }>): Promise<User> {
  return await client.put<User>(`/users/${userId}`, data)
}

export async function deleteUser(userId: number): Promise<void> {
  await client.delete(`/users/${userId}`)
}

export async function setUserPassword(userId: number, new_password: string): Promise<void> {
  await client.post(`/users/${userId}/set-password`, { new_password })
}
